// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { FilterType } from "../../types"

// Utils
import { useApi } from "utils"
import { PERMISION } from "security"

export function useCoaGroup(): {
  data: FilterType[],
  isLoading: boolean
} {
  // Vars
  const permissionGroupList: {
    [key: string]: string
  } = {
    "": PERMISION.ACCOUNTS.REGISTER.SHOW_ALL.PERMISION,
    "01": PERMISION.ACCOUNTS.REGISTER.ASSET.PERMISION,
    "02": PERMISION.ACCOUNTS.REGISTER.COST_OF_SALE.PERMISION,
    "03": PERMISION.ACCOUNTS.REGISTER.EQUITY.PERMISION,
    "04": PERMISION.ACCOUNTS.REGISTER.EXPENSE.PERMISION,
    "05": PERMISION.ACCOUNTS.REGISTER.INCOME.PERMISION,
    "06": PERMISION.ACCOUNTS.REGISTER.INCOME_TAX.PERMISION,
    "08": PERMISION.ACCOUNTS.REGISTER.LIABILITY.PERMISION,
    "09": PERMISION.ACCOUNTS.REGISTER.OTHER_EXPENSE.PERMISION || PERMISION.ACCOUNTS.REGISTER.OTHER_INCOME.PERMISION
  }
  const show_all = {
    label: "Show All",
    value: ""
  }

  // Hooks
  const api = useApi()
  const [data, setData] = useState<FilterType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/groupcoa/").then((res: SuccessFetch<{
      payload: {
        group_coa_code: string
        group_coa_name: string
      }[]
    }>) => {
      setData([
        {
          ...show_all,
          permission: permissionGroupList[show_all.value]
        },
        ...res.data.payload.map(item => {
          return {
            label: item.group_coa_name,
            value: item.group_coa_code,
            permission: permissionGroupList[item.group_coa_code]
          }
        })
      ])
    }).catch(() => {
      setData([{
        ...show_all,
        permission: permissionGroupList[show_all.value]
      }])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}